import { DictionaryItem } from "./metric";

export class Algorithm {
    id: string;
    name: string;
    outputs: AlgorithmOutput[];
}

export class AlgorithmOutput {
    name: string;
    unit: string;
    label: string;
    type: AlgorithmOutputType;
    dictionary: DictionaryItem[];
}

export enum AlgorithmOutputType {
    INTEGER = 'INTEGER',
    FLOAT = 'FLOAT',
    BOOLEAN = 'BOOLEAN',
    LONG = 'LONG',
    STRING = 'STRING'
}